import { v4 as uuidv4 } from 'uuid';

import { readCookie } from '@zapier/cookies';

import * as CliApp from 'app/entities/CliApp';
import * as Profile from 'app/entities/Profile';
import { trackEvent } from 'app/track/trackingFunctions';
import { currentAppId, currentAppEntity } from 'app/developer-v3/selectors';
import { State } from 'app/common/types';

export type PartnerUserInteractionEventTrackerArgs = {
  causationId?: string;
  /**
   * A UUID used to link events together (e.g. FE button click with BE
   * success/fail)
   */
  correlationId?: string;
  /** The action that originated this event (e.g. upgrade, downgrade, click) */
  eventAction: string;
  /** The event ID, defaults to a random UUID v4 */
  eventId?: string;
  /** The name of the button or interaction in the code */
  interactionName: string;
  /** The final goal of the interaction (e.g. enable_aac) */
  interactionGoal: string;
  /** The ID of the user who is the subject of the interaction */
  targetCustomuserId?: number;
};

export type PartnerUserInteractionEventTracker = ({
  causationId,
  correlationId,
  eventAction,
  interactionGoal,
  interactionName,
  targetCustomuserId,
}: PartnerUserInteractionEventTrackerArgs) => void;

/**
 * Takes the redux state and returns a tracking function for
 * PartnerUserInteractionEvent
 */
// TODO: add casuationId to avro schema and here. "The fields event_id, correlation_id, and causation_id SHOULD be included when defining new Avro event schemas" from https://engineering.zapier.com/guides/event-streaming/commands/#correlation-and-causation
export function createPartnerUserInteractionEventTracker(
  reduxState: State
): PartnerUserInteractionEventTracker {
  const appEntity = currentAppEntity(reduxState);

  const absolute_url = location.href;
  const account_id = Profile.selectors.all.currentProfileId(reduxState);
  const customuser_id = account_id; // Why is this the same?
  const identity_id = readCookie('zapidentity');
  const integration_id = Number(currentAppId(reduxState));
  const referer = document.referrer;
  const release_id = process.env.COMMIT_HASH;
  const screen_size = `${screen.width}x${screen.height}`;
  const service_id = CliApp.selectors.serviceId(appEntity);
  const url_address = location.pathname;
  const user_agent = navigator.userAgent;
  const visitor_id = readCookie('visitor_id');

  return function trackInteraction({
    correlationId: correlation_id = uuidv4(),
    eventAction: event_action,
    eventId: event_id = uuidv4(),
    interactionGoal: interaction_goal,
    interactionName: interaction_name,
    targetCustomuserId: target_customuser_id = null,
  }) {
    const timestamp_ms = Date.now();
    trackEvent('schema:partner.app.platform.PartnerUserInteractionEvent', {
      absolute_url,
      account_id,
      correlation_id,
      customuser_id,
      event_action,
      event_id,
      identity_id,
      interaction_goal,
      integration_id,
      interaction_name,
      referer,
      release_id,
      screen_size,
      service_id,
      timestamp_ms,
      url_address,
      user_agent,
      target_customuser_id,
      visitor_id,
    });
  };
}
